// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3MOs4","amount":"Amount_amount__Mw-B2","tip":"Amount_tip__1nYdD","tipHeader":"Amount_tipHeader__2uAOF","tipsWrap":"Amount_tipsWrap__14yyR"};